define.alias("ember-composable-helpers/helpers/shuffle", "calendar/helpers/shuffle");